var spoiler_default = {
  "fontElementMap": "pge8b",
  "hideText": "FgjOS",
  "onHoverText": "R3l1A",
  "hideBlock": "_0moHC",
  "smallBlur": "kN00k",
  "mediumBlur": "ZoYR6",
  "largeBlur": "zKufG",
  "hideBlock_gallery": "RuT-V",
  "overlay": "eLgLI",
  "overlay_gallery": "JbM67",
  "revealSpoilerBtn": "dneE0",
  "isMobile": "tO-Ge",
  "onHoverBtn": "_1zrn9",
  "spoilerWrapper": "nLOlA",
  "spoilerDescription": "RF-Gv",
  "spoilerContainer": "gEjTM",
  "spoilerContainer_Gallery": "cjbl0"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
